import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const StyledFieldButton = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--gap-x10);
`;

export const Buttons = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: var(--gap-x3);
`;

export const input = css`
	width: 300px;
`;
